<template>
  <div class="pop-tree">

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 fixed-text-box" v-html="$lang.f3_1_header"></div>
        <div class="pure-u-1-2 pure-u-md-1-2 icon-holder">
          <div class="icon f3_main"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_2_header"></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2">
          <div class="icon-header right pure-g">
            <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
            <a :href="'./static/documents/09.pdf'" download="studiematerial_09" class="icon p-2-sheet-0 pure-u-1-3" v-touch:tap="downloadFact2Document"></a>
          </div>

        </div>
      </div>
    </div>

    <div class="lvl-section trees">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <h3 v-html="$lang.f3_2_1_header"></h3>
          <p v-html="$lang.f3_2_1_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <h3 v-html="$lang.f3_2_2_header"></h3>
          <p v-html="$lang.f3_2_2_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <h3 v-html="$lang.f3_2_3_header"></h3>
          <p v-html="$lang.f3_2_3_txt"></p>
          <ul class="ul-padding" v-html="$lang.f3_2_3_ul"></ul>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_3_header"></h2>
          <p v-html="$lang.f3_3_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="dataSlides[0].slides"
      :extraHeightClass="'bio-height'"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_4_header"></h2>
          <p v-html="$lang.f3_4_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="dataSlides[1].slides"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_5_header"></h2>
          <!--<p v-html="$lang.f3_5_ingress"></p>-->
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="dataSlides[2].slides"
      :showDots="false"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_6_header"></h2>
          <p v-html="$lang.f3_6_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="dataSlides[3].slides"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_7_header"></h2>
          <p v-html="$lang.f3_7_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="dataSlides[4].slides"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f3_8_header"></h2>
          <p v-html="$lang.f3_8_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div class="lvl-section fives">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-5">
          <div class="icon f3_6_1"></div>
          <h4 v-html="$lang.f3_6_1_header"></h4>
          <p v-html="$lang.f3_6_1_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-5">
          <div class="icon f3_6_2"></div>
          <h4 v-html="$lang.f3_6_2_header"></h4>
          <p v-html="$lang.f3_6_2_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-5">
          <div class="icon f3_6_3"></div>
          <h4 v-html="$lang.f3_6_3_header"></h4>
          <p v-html="$lang.f3_6_3_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-5">
          <div class="icon f3_6_4"></div>
          <h4 v-html="$lang.f3_6_4_header"></h4>
          <p v-html="$lang.f3_6_4_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-5">
          <div class="icon f3_6_5"></div>
          <h4 v-html="$lang.f3_6_5_header"></h4>
          <p v-html="$lang.f3_6_5_txt"></p>
        </div>
      </div>
    </div>

    <div class="note-box light-beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2">
          <div class="icon f-note"></div>
          <p v-html="$lang.f3_note"></p>
        </div>
        <div class="pure-u-md-1-3"></div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2" v-touch:tap="toggleRefs">
          <h2 class="toggle-ref">{{$lang.refs}} <span :class="{'open': showRefs}"></span></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Refferens -->
    <div class="lvl-section refs">
      <transition name="show-ref">
        <div v-show="showRefs" class="pure-g refs-container">
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f3_ref_1"></div>
          </div>
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f3_ref_2"></div>
          </div>
          <!--<div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">-->
            <!--<div class="lvl-body" v-html="$lang.f3_ref_3"></div>-->
          <!--</div>-->
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import BGSlider from '../../../components/big-slider'
import DataSlider from '../../../assets/data/fact3_slides.json'

export default {
  name: 'fact-three',
  data () {
    return {
      dataSlides: DataSlider.all_slides,
      showRefs: false
    }
  },
  methods: {
    toggleRefs () {
      let self = this
      return self.onToggleRefs()
    },
    onToggleRefs () {
      this.showRefs = !this.showRefs
    },
    downloadFact2Document () {
      this.$ga.event('Downloads', 'click', 'Symptom', 5)
    }

  },
  components: {
    'bg-slider': BGSlider
  }
}
</script>



// WEBPACK FOOTER //
// src/components/facts/fact3/index.vue